/**
 * Add extra Google Tag Manager handling for Cookie Consent
 */
import {BasePlugin} from './BasePlugin';

export class GoogleTagManager extends BasePlugin {
    options = {
        categoryToConsentStorageConverter: GoogleTagManager.getConsentStorageByCategory,
    };

    destroyController = new AbortController();

    /**
     * Hook into cookieConsent to push data to GTM
     *
     * @param {Object} options
     */
    constructor(options = {}) {
        super();

        this.options = {...this.options, ...options};

        if (typeof window.dataLayer === 'undefined') {
            window.dataLayer = [];
        }
    }

    initialize(cookieConsent) {
        super.initialize(cookieConsent);
        this.forwardEvents();
    }

    destroy() {
        this.destroyController.abort();
    }

    /**
     * Google tag API
     */
    static gtag() {
        // eslint-disable-next-line no-console
        console.info('GTM datalayer push', arguments); // This will be stripped in prod build
        window.dataLayer.push(arguments);
    }

    /**
     * Get consent storage name by category
     *
     * @param {String} category
     * @return {String}
     */
    static getConsentStorageByCategory(category) {
        switch (category) {
            case 'analytical':
            case 'analytics':
                return 'analytics_storage';
            case 'marketing':
            case 'ads':
                return 'ad_storage';
            default:
                return 'unknown';
        }
    }

    /**
     * Hook into useful events to push their data to GTM
     */
    forwardEvents() {
        // Send loaded event if we are sure all consent events are sent.
        this.dialog.addEventListener('consentLoaded', e => this.onConsentLoaded(e), {
            signal: this.destroyController.signal,
        });

        // Hook into the answer event to push answer data to GTM. Used to forward this info to Google Analytics.
        this.dialog.addEventListener('answer', e => this.onAnswer(e), {
            signal: this.destroyController.signal,
        });

        // Hook into the activateCategory event to push answer data to GTM. Used to forward this info to Google
        // Analytics.
        this.dialog.addEventListener('activateCategory', e => this.onActivateCategory(e), {
            signal: this.destroyController.signal,
        });
    }

    onConsentLoaded() {
        GoogleTagManager.gtag('event', 'cookie-consent-loaded');
    }

    onActivateCategory(e) {
        const consentStorage = this.options.categoryToConsentStorageConverter(e.detail.category);
        GoogleTagManager.gtag('consent', 'update', {
            [consentStorage]: 'granted',
        });
        GoogleTagManager.gtag('event', 'cookie-consent-' + e.detail.category);
    }

    onAnswer(e) {
        GoogleTagManager.gtag('event', 'cookie-consent-answer', {
            consent: e.detail.consent,
            categories: e.detail.categories ? e.detail.categories.join(', ') : '/',
        });
        GoogleTagManager.gtag('event', 'cookie-consent-loaded');
    }
}
